import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

const InjectMassage = (props: ComponentProps<typeof FormattedMessage>) => {
  return <FormattedMessage {...props} />;
};

export default InjectMassage;
